module.exports = __webpack_public_path__ + "static/img/shanchu.f0edd6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/shanchu.png
// module id = ZRGt
// module chunks = 24